import { Tag as TagAntd } from "@empglabs/backoffice-ui-kit"

const Tag = props => {
  return <TagAntd {...props} />
}

export default Tag
